export const AppConstants = {
  validationTokenHours: 8,
  alertCertificateDaysExpiration: 30,
  minutesLimitInactive: 15,
  monthsDiffBetweenTwoDates: 12,
  maxLengthFilters: 100,
  maxElementsInputWithSearch: 200,
  maximaLongitudNombreFichero: 64,
  tamanyoMaximoFicheroEnBytes: 5242880,
  minNumPuertas: 0,
  defaultNumPuertas: 0,
  typesMailBox: ["Certificados", "COC", "Placa"],
  frecuency: ["Diaria", "Semanal", "Mensual", "Desactivar"],
  footerPDF: {
    SE: "\nSEAT, S.A. Sdad.Unipersonal - Dom.Soc.: Autovía A-2 Km 585 - 08760 Martorell. Reg. Merc.Barcelona: Tomo 23662, Folio 1, Hoja 56855 - NIF A28049161",
    VW: "\nVolkswagen Group España Distribución, S.A. - Sdad.Unipersonal - Dom.Soc.: Avinguda del Parc Logístic 12-20, 08040 Barcelona. Reg. Merc.Barcelona: Tomo 24887, Folio 171, Hoja 80744 - (VAT) NIF (ES)A60198512",
    SK: "\nVolkswagen Group España Distribución, S.A. - Sdad.Unipersonal - Dom.Soc.: Avinguda del Parc Logístic 12-20, 08040 Barcelona. Reg. Merc.Barcelona: Tomo 24887, Folio 171, Hoja 80744 - (VAT) NIF (ES)A60198512",
    AU: "\nVolkswagen Group España Distribución, S.A. - Sdad.Unipersonal - Dom.Soc.: Avinguda del Parc Logístic 12-20, 08040 Barcelona. Reg. Merc.Barcelona: Tomo 24887, Folio 171, Hoja 80744 - (VAT) NIF (ES)A60198512",
    CANARIAS:
      "\nDomingo Alonso, S.L.U. - Sociedad Limitada Unipersonal - Dom. Soc.: Avd. Pintor Felo Monzón, 34 Bajo, 35019 Las Palmas de Gran Canaria. Reg. Merc. \nLas Palmas de GC: Tomo 1979, Folio 213, Hoja GC-5769- (VAT) NIF (ES) B-35007376",
  },
  roles: {
    ADMIN: "ADMIN",
    ANALISTA: "ANALISTA",
    RHOMOLOG: "RHOMOLOG",
    RREGION: "RREGION",
    CONCES: "CONCES",
    IMPORT: "IMPORT",
    REVISOR: "REVISOR",
    ABASICO: "ABASICO",
    AAVANZA: "AAVANZA",
    TECNICO: "TECNICO",
  },
  regionsOfConcessionarie: ["SEAT", "VOLKSWAGEN", "CANARIAS"],
  castDynamicsFields: [
    //Marcamos null el type cuando no queremos que sea editable
    {
      id: "paramDetallePeticionFichero",
      text: "Fichero excel de bastidores",
      type: "FILE",
    },
    {
      id: "paramDetallePeticionFecPriMat",
      text: "Fecha primera matriculación",
      type: "DATE",
    },
    {
      id: "paramDetallePeticionNumero_Bastidores",
      text: "Número bastidores",
      type: "INT",
    },
    {
      id: "paramDetallePeticionMarca",
      text: "Marca Vehículos",
      type: "STATICLIST",
      list: [
        { label: "SEAT/CUPRA", valor: "SEAT" },
        { label: "VW/AUDI/SKODA", valor: "VOLKS" },
      ],
    },
    {
      id: "paramDetallePeticionFactura",
      text: "Fichero documentación",
      type: "FILE",
    },
    {
      id: "NumeroPuertas",
      text: "Número de puertas",
      type: "INT",
    },
    {
      id: "MotivoReedicion",
      text: "Motivo de reedición",
      type: "DBLIST",
      list: "MOTIVO_REEDICION",
    },
    {
      id: "TipoPlaca",
      text: "Tipo de placa",
      type: "DBLIST",
      list: "TPLACA",
    },
    {
      id: "FicheroAdjunto",
      text: "Ficha técnica",
      type: "FILE",
    },
  ],
};
